import { Typography, styled } from "@material-ui/core";

export const ToggleText = styled(Typography)({
  color: "#2E3860",
  textAlign: "center",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "12px",
  fontWeight: 600,
});
